import React from "react";
import { UserDeviceSettingsEmptyStateTemplate } from "themes/administration/user/components";

const UserDeviceSettingsEmptyState = (props) => {
    return <UserDeviceSettingsEmptyStateTemplate {...props} />;
};

export default UserDeviceSettingsEmptyState;
